import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import RequestOrderInvoice from './RequestOrderInvoice';
import UnsubscribeProduct from './UnsubscribeProduct';

const ProductControlModal = (props) => {
    const [orderControlModal, setOrderControlModal] = useState({ toggle: false, activity: null });

    const {
        modalStyles, modalWidth, modalTitleStyle, modalInfoTextStyle,
        userData,
        productOrder,
        companyData,
    } = props;
    const { orderId, subscriptionActivity } = productOrder;
    let boughtOrderId = 'boughtSubscription' in companyData ? companyData.boughtSubscription.orderId : null;
    const subscriptionBoughtActive = boughtOrderId === orderId ? companyData.boughtSubscription.applied ? <a href="#!" onClick={() => { setOrderControlModal({ toggle: true, activity: subscriptionActivity }) }} className="btn btn-sm btn-outline-danger">Unsubscribe</a> : <a href="#!" onClick={() => { setOrderControlModal({ toggle: true, activity: subscriptionActivity }) }} className="btn btn-sm btn-outline-danger">Unsubscribe</a> : <React.Fragment />


    const requestInvoice = <a href="#!" onClick={() => { setOrderControlModal({ toggle: true, activity: null }) }} className="">Get invoice</a>
    const relevantActionButton = subscriptionActivity === 'active' || subscriptionActivity === 'trialing' ? <React.Fragment>{requestInvoice}</React.Fragment> : subscriptionActivity !== 'requiresAuth' ? requestInvoice : <React.Fragment />

    // console.log(subscriptionActivity)
    const relevantModalBody = orderControlModal ? orderControlModal.activity === 'active' || orderControlModal.activity === 'trialing' ? <UnsubscribeProduct orderId={orderId} /> : orderControlModal.activity !== 'requiresAuth' ? <RequestOrderInvoice orderId={orderId} /> : <React.Fragment /> : <React.Fragment />

    return (
        <React.Fragment>
            {relevantActionButton}

            {/* CONTROL MODAL */}
            <ReactModal
                style={modalStyles}
                isOpen={orderControlModal.toggle}
                onRequestClose={() => { setOrderControlModal({ toggle: false }) }}
                contentLabel="See order controls"
                ariaHideApp={false}
            >
                <button className="close" onClick={() => { setOrderControlModal({ toggle: false }) }}>
                    <span aria-hidden="true">&times;</span>
                </button>
                <div className="dynamicModalContainer">
                    <div className="dynamicModalSm">
                        <div className="px-3">
                            <p style={modalTitleStyle}>Order settings</p>
                            <blockquote className="blockquote">
                                <h3><span></span><span style={{ color: "gray" }}>{productOrder.itemName}</span></h3>
                                <footer className="blockquote-footer">Subscription renews every {productOrder.subscriptionPeriod}</footer>
                            </blockquote>
                            {/* <br /> */}
                            {relevantModalBody}
                            <br />
                        </div>
                    </div>
                </div>
            </ReactModal>
        </React.Fragment>
    );
};


const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,

        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,

        userData: state.firebase.profile,
        userId: state.firebase.auth.uid,

        companyData: state.firestore.data.Company,
    }
}

export default connect(mapStateToProps)(ProductControlModal);